<template>
  <div class="ui basic segment" id="wrapper">
    <Spinny :promise="publicationPromise" :message="$t('READ', { thing: $tc('PUBLICATION', 2) })" />

    <div v-if="alreadyInstalled.length > 0" class="ui icon error message">
      <i class="exclamation triangle icon" />
      <div class="content">
        {{ $t('ALREADY_INSTALLED', { name: publication.name }) }}
        <ul>
          <li v-for="item in alreadyInstalled" :key="item.id">
            <router-link :to="{ name: 'app-settings', params: { appId: item.application } }">
              {{ applicationFor(item.application) && applicationFor(item.application).name }}
            </router-link>
            -
            <router-link
              :to="{
                name: 'app-flow',
                params: { appId: item.application, flowId: item.id, mode: 'settings' }
              }"
              >{{ item.name }}</router-link
            >
          </li>
        </ul>
      </div>
    </div>
    <template v-else-if="alreadyInstalled.length === 0 && publication">
      <dropdown-select
        :labelText="$t('CHOOSE_APP_FOR_INSTALL', { name: publication.name })"
        :items="applicationItems"
        :optional="true"
        @selected="selectApplication"
      />

      <PublicationGetter
        :appId="selectedApplication && selectedApplication.id"
        :publication="publication"
        :showAbstract="true"
      />
    </template>
    <div v-else class="ui icon error message">
      <i class="meh outline icon" />
      <span class="capitalize-fl">{{ $t('NO_SUCH', { thing: $tc('FLOW', 1) }) }}</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
#wrapper {
  padding-left: 20px;
  padding-right: 30px;

  ul {
    margin-top: 10px;
  }
}
</style>

<script>
// @flow
import Vue from 'vue'
import { Spinny, DropdownSelect } from 'ui'
import { Flow, Hub, Application } from 'services'
import PublicationGetter from './PublicationGetter'

export default {
  name: 'hub-handler',
  components: { Spinny, DropdownSelect, PublicationGetter },
  props: ['type', 'origin', 'identifier'],

  data() {
    return {
      publication: {},
      publicationPromise: null,
      selectedApplication: null
    }
  },

  computed: {
    applications() {
      return this.$store.state.application.items
    },

    applicationItems() {
      // dont show apps where the flow is already installed
      return _.filter(
        this.applications,
        a => !_.find(this.alreadyInstalled, f => a.id === f.application)
      )
    },
    flows() {
      return this.$store.state.flow.items
    },
    alreadyInstalled() {
      return _.filter(this.flows, f => f.publication?.identifier === this.identifier)
    }
  },

  methods: {
    selectApplication(a) {
      this.selectedApplication = a
    },
    applicationFor(id) {
      return _.find(this.applications, a => a.id === id)
    }
  },

  mounted() {
    Flow.readAllFlows()
    Application.readAllApps()

    this.publicationPromise = Hub.connections().then(conns =>
      Promise.all(_.flatMap(conns, Hub.latest)).then(pubs => {
        const items = _.flatMap(pubs, p => p.body && p.body.items)
        this.publication = _.find(items, item => item.identifier === this.identifier)
      })
    )
  }
}
</script>
